<template>
  <section class="bg-static-default-low rounded-lg border px-24 pb-16 pt-24">
    <table class="w-full">
      <thead>
        <tr>
          <th class="w-1/2 px-6 text-center pb-16">
            {{ firstColumnTitle }}
          </th>
          <th class="w-1/2 px-6 text-center pb-16">
            {{ secondColumnTitle }}
          </th>
        </tr>
      </thead>
      <tbody class="divide-static-default-low divide-y">
        <slot name="rows" />
      </tbody>
    </table>
  </section>
</template>

<script setup lang="ts">
defineProps<{
  firstColumnTitle: string
  secondColumnTitle: string
}>()
</script>
